import { render } from "./movdevolucao-editar.vue?vue&type=template&id=41f0df63"
import script from "./movdevolucao-editar.vue?vue&type=script&lang=js"
export * from "./movdevolucao-editar.vue?vue&type=script&lang=js"

import "./movdevolucao-editar.vue?vue&type=style&index=0&id=41f0df63&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__